import { IconCheckCircle, IconSize, NormalTroubleshooting } from '@/components'
import { SystemStatusEnum } from '@/enums'
import { SystemStatusDataType } from '@/types'

export const SYSTEM_STATUSES_MONITORED_NORMAL: SystemStatusDataType[] = [
    {
        value: SystemStatusEnum.NORMAL,
        title: 'Normal',
        refreshable: true,
        icon: (size: IconSize) => <IconCheckCircle size={size}/>,
        description: 'All systems are functioning within normal parameters; no immediate action is required.',
        troubleshooting: <NormalTroubleshooting/>
    }
]
